
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-teal-50 to-emerald-50 border-t border-teal-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* About Section */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/853dbb08f880e8122464f2674851b25b/342cf673f7edb3c022d294dc29656eb7.png" 
                alt="성덕사 로고" 
                className="h-12 w-auto object-contain"
              />
              <span className="text-2xl font-serif font-bold text-gray-800">성덕사</span>
            </div>
            <p className="text-gray-600 leading-relaxed">
              마음의 평화를 찾는 곳, 성덕사에서 부처님의 가르침과 함께 하세요.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold text-gray-800 mb-4">빠른 링크</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap">
                  성덕사 소개
                </Link>
              </li>
              <li>
                <Link to="/dharma" className="text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap">
                  법회안내
                </Link>
              </li>
              <li>
                <Link to="/practice" className="text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap">
                  신행안내
                </Link>
              </li>
              <li>
                <Link to="/community" className="text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap">
                  참여마당
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold text-gray-800 mb-4">연락처</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-teal-600"></i>
                </div>
                <span className="text-gray-600">서울특별시 중랑구 봉화산로 109-8</span>
              </li>
              <li className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-teal-600"></i>
                </div>
                <span className="text-gray-600">02-434-7171</span>
              </li>
              <li className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-teal-600"></i>
                </div>
                <span className="text-gray-600">sungduksa7@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-teal-100 bg-white/50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
            <p className="text-sm text-gray-600">
              © 2024 성덕사. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-600 hover:text-teal-600 transition-colors whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
